import { render } from "./PurchaseButton.vue?vue&type=template&id=32af029c"
import script from "./PurchaseButton.vue?vue&type=script&lang=js"
export * from "./PurchaseButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__